import React from 'react';
import './RecommendedValuesPerAge.css';
import { useTranslation } from 'react-i18next';
import AirwaysRecommendedValues from './AirwaysRecommendedValues';
import MedicalProceduresRecommendedValues from './MedicalProceduresRecommendedValues';

const RecommendedValuesPerAge: React.FC = () => {
  const { t } = useTranslation(['resus']);

  return (
    <>
      <h5 className="recommended-values-title">{t('airways.recommendedValues')}</h5>
      <div>      
      <AirwaysRecommendedValues showTitle={false} />
      <MedicalProceduresRecommendedValues showTitle={false} />
      </div>
    </>
  );
};

export default RecommendedValuesPerAge;
